import React from 'react'
import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type FormConfirmProps = {
  text: string
}

export const FrontTabletFormConfirmText = ({ text }: FormConfirmProps) => {
  return <p css={itemTextStyle}>{text}</p>
}

const itemTextStyle = css(
  {
    fontSize: 24,
    color: '#272727',
    lineHeight: '30px',
    letterSpacing: '1.2px',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      fontSize: 28,
      lineHeight: '35px',
      letterSpacing: '1.4px',
    },
  }),
)
